import React, { useState } from "react";
import "./App.css";
import { URL } from "./constants";
import { Helmet } from "react-helmet";

function Home() {

  const [question,setQuestion]=useState('');
  const [result,setResult]=useState(undefined);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const payload = {
    contents: [
      {
        parts: [
          {
            text: question
          }
        ]
      }
    ]
  }

  const askQuestion = async () => {

    if (!question.trim()) {
      alert("Please enter a topic!");
      return;
    }

    setLoading(true);
    setResult("");

    let response = await fetch(URL,{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body:JSON.stringify(payload)
    });

    response = await response.json();

    if(response.candidates && response.candidates.length > 0){
      setResult(response.candidates[0].content.parts[0].text);
    }else{
      setResult("Error generating paragraph. Please try again.");
    }

    setLoading(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <>
    <Helmet>

      <title>PRO AI Paragraph Generator | Free Paragraph Generator Tool</title>

      <meta
        name ="description"
        content="Generate high-quality paragraphs instantly using our AI Paragraph Generator. Rewrite AI text to human text, copy and paste paragraphs, and use AI paragraph rewriter tools for free."
      />

      <meta
        name="keywords"
        content="Pro AI Paragraph Generator, Paragraph generator copy and paste, Easy content generator for bloggers, paragraph generator ai, blog post content generator, Perfect paragraph generator Writers, perfect paragraph generator for students, high-quality paragraphs generator, AI Text Rewriter Free, Generate AI Content, Keyword-Based Writing, Multi-Language paragraph generator, AI Content Improver, Social Media Content generator, Rewrite AI Text to Human Text, AI paragraph generator free, paragraph writing tool"
      />

      <link rel="canonical" href="https://proaiparagraph.vercel.app/home" />

      <meta property="og:title" content="AI Paragraph Generator - Free AI Writing Tool" />
      <meta property="og:description" content="Create and rewrite paragraphs instantly with AI tools. Copy, paste, and humanize AI text easily." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://proaiparagraph.vercel.app/home" />

    </Helmet>

    <div className="home-container">

      <section className="hero-section">
        <h1>PRO AI Paragraph Generator</h1>

        <p>
          Our <strong>PRO AI Paragraph Generator</strong> helps you instantly
          generate high-quality paragraphs on any topic using artificial
          intelligence. This <strong>free paragraph generator</strong> is
          perfect for students, writers, bloggers, and content creators.
        </p>

        <div className="gen-wrapper">

          <div className="gen-card">

            <div className="gen-header">
              <h3>Generate Your Paragraph</h3>
              <p>Enter any topic and let AI do the magic ✨</p>
            </div>

            <div className="gen-input-area">
              <textarea
                placeholder="Type your topic here... (e.g. Artificial Intelligence, Success, Motivation)"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </div>

            <div className="gen-actions">
              <button className="gen-btn" onClick={askQuestion}>
                {loading ? "Generating..." : "Generate"}
              </button>

              {result && (
                <button className="copy-btn" onClick={handleCopy}>
                  {copied ? "Copied!" : "Copy"}
                </button>
              )}
            </div>

            {loading && (
              <div className="gen-loader">
                <div className="loader"></div>
                <p>AI is writing your paragraph...</p>
              </div>
            )}

            {result && (
              <div className="gen-result">
                <h4>Generated Paragraph</h4>
                <p>{result}</p>
                {copied && <span className="copy-msg">Copied!</span>}
              </div>
            )}

          </div>

        </div>

      </section>

      <section className="how-section">

        <h2>How Our PRO AI Paragraph Generator Works</h2>

        <div className="how-grid">

          <div className="how-card">
            <h3>Enter Topic</h3>
            <p>Type any topic to start generating content.</p>
          </div>

          <div className="how-card">
            <h3>Generate AI Content</h3>
            <p>Our paragraph generator AI creates meaningful text instantly.</p>
          </div>

          <div className="how-card">
            <h3>Copy & Use</h3>
            <p>Use paragraph generator copy and paste feature anywhere.</p>
          </div>

        </div>

      </section>

      <section className="features-section">

        <h2>Why Use Our Free PRO AI Paragraph Generator?</h2>

        <div className="features-grid">

          <div className="feature-card">
            <h3>Fast AI Generation</h3>
            <p>Generate paragraphs instantly using advanced AI.</p>
          </div>

          <div className="feature-card">
            <h3>Easy to Use</h3>
            <p>Simple interface for quick paragraph creation.</p>
          </div>

          <div className="feature-card">
            <h3>Perfect for Writers</h3>
            <p>Great for blogs, essays, and academic work.</p>
          </div>

          <div className="feature-card">
            <h3>Unlimited Topics</h3>
            <p>Create content on any subject anytime.</p>
          </div>

        </div>

      </section>

      <section className="tools-section">

        <h2>Advanced AI Writing Tools</h2>

        <div className="features-grid">

          <div className="feature-card">
            <h3>Paragraph Generator Copy and Paste</h3>
            <p>
              Quickly generate content and use our paragraph generator copy and paste
              feature to reuse text anywhere without hassle.
            </p>
          </div>

          <div className="feature-card">
            <h3>Paragraph Generator AI</h3>
            <p>
              Our paragraph generator AI helps you create high-quality and meaningful
              content in seconds for any topic.
            </p>
          </div>

          <div className="feature-card">
            <h3>AI Paragraph Rewriter</h3>
            <p>
              Use our AI paragraph rewriter to rewrite existing content and improve
              readability and clarity instantly.
            </p>
          </div>

          <div className="feature-card">
            <h3>AI Text Rewriter Free</h3>
            <p>
              Enjoy AI text rewriter free tool to edit and enhance your writing
              without any cost.
            </p>
          </div>

          <div className="feature-card">
            <h3>Rewrite AI Text to Human Text</h3>
            <p>
              Easily rewrite AI text to human text and make your content more natural,
              engaging, and reader-friendly.
            </p>
          </div>

          {/* NEW CARDS ADDED BELOW */}

          <div className="feature-card">
            <h3>Blog Content Generator</h3>
            <p>Create SEO-friendly blog paragraphs instantly for your website.</p>
          </div>

          <div className="feature-card">
            <h3>Essay Writing Assistant</h3>
            <p>Generate structured paragraphs for academic essays easily.</p>
          </div>

          <div className="feature-card">
            <h3>Social Media Content</h3>
            <p>Write engaging captions and posts for social media platforms.</p>
          </div>

          <div className="feature-card">
            <h3>Content Improver</h3>
            <p>Enhance clarity, tone, and readability of your existing content.</p>
          </div>

          <div className="feature-card">
            <h3>Keyword-Based Writing</h3>
            <p>Generate paragraphs based on specific keywords for better SEO.</p>
          </div>

          <div className="feature-card">
            <h3>Multi-Language Support</h3>
            <p>Create content in different languages quickly and efficiently.</p>
          </div>

        </div>

      </section>

    </div>
    </>
  );
}

export default Home;